import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { VerifyCode } from '../../redux/Slices/AuthSlice'
import notify from '../UseNotification'
import { useNavigate } from 'react-router-dom'

const UseVerfiyCode = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [verfiyCode, setVerfiyCode] = useState()
    const [loading, setLoading] = useState()
    const [isPress, setIsPress] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)
    const { ResetCode } = useSelector(state => state.AuthReducer)

    // Change verfiy code
    const onChangeVerfiyCode = (e) => {
        setVerfiyCode(e.target.value)
    }

    // handle validate code
    const validateCode = (e) => {
        if (e.target.value === "") {
            notify("Please enter the code", "error")
        }
    }

    // to handle disable submit button
    useEffect(() => {
        if (verfiyCode && verfiyCode.length > 0) {
            setIsFormValid(true)
        } else {
            setIsFormValid(false)
        }
    }, [verfiyCode])


    // submit
    const Submit = async () => {
        setIsPress(true)
        setLoading(true)
        await dispatch(VerifyCode({
            resetCode: verfiyCode
        }))
        setLoading(false)
    }

    // to handle the response from the request
    useEffect(() => {
        if (loading === false) {
            setIsPress(true)
            if (ResetCode.data) {
                if (ResetCode.data.status === "Success") {
                    localStorage.removeItem("token")
                    notify("the code is correct", "success")
                    navigate("/user/resetpassword")
                }
            }
            else if (ResetCode.response.status === 500) {
                localStorage.removeItem("token")
                notify("please enter the code", "error")
            }
            else if (ResetCode.response.status === 400) {
                localStorage.removeItem("token")
                notify(ResetCode.response.data.message, "error")
            }
        }
    }, [loading])


    return [verfiyCode, onChangeVerfiyCode, Submit, isPress, loading, validateCode, isFormValid]
}

export default UseVerfiyCode
